import * as Yup from 'yup'

import { FC, HTMLAttributes, useEffect } from "react"

import { FieldError } from '../../../../../widgets'
import { IEntity } from "../../../../../base/types"
import { ILookupProps } from './ILookupProps'
import { Typeahead } from 'react-bootstrap-typeahead'
import clsx from 'clsx'
import { useFormContext } from "../../form"
import { useFormikContext } from "formik"
import { useLookupData } from './useLookupData'
import { useLookupValidationSchema } from './LookupValidationSchema'

interface ILookupFieldProps extends HTMLAttributes<HTMLInputElement>, ILookupProps {
    name: string
}

export const LookupField: FC<ILookupFieldProps> = (props) => {
    const { id, name, className, disabled, tableLookup } = props

    const shape = useLookupValidationSchema(props)
    const { getFieldProps, setFieldValue, setFieldTouched, values, errors, touched } = useFormikContext<IEntity>() || {}
    const { updateSchema } = useFormContext()
    const { lookupData, isLoading } = useLookupData(tableLookup)

    useEffect(() => {
        if (!name || !shape) return;

        const schema = Yup.object().shape({ [name]: shape });
        updateSchema(schema);

        // eslint-disable-next-line
    }, [name, shape])

    const handleOnChange = (selected: Record<string, any>) => {
        const value = selected[0];

        if (value) {
            setFieldValue(name, value["id"], true)
        } else
            setFieldValue(name, undefined, true)
    }

    let fieldProps = name ? getFieldProps(`['${name}']`) : { value: '' }
    if (fieldProps.value === undefined)
        fieldProps = { ...fieldProps, value: '' }

    return (<>
        <Typeahead
            id={id}
            className={clsx(className, "custom-typeahead typeahead-sm")}
            labelKey="label"
            isLoading={isLoading}
            clearButton={true}
            disabled={disabled}
            options={lookupData}
            filterBy={['label']}
            onChange={handleOnChange}
            onBlur={() => setFieldTouched(name, true, true)}
            selected={lookupData.filter(p => p.id === values[name]) || ''}
        />

        <FieldError show={touched[name] && !!errors[name]} message={`${errors[name]}`} />
    </>
    )
}

